import React, { ReactNode, useState } from "react";
import "./FlushAccordian.css"

interface IFlushAccordian {
    title: string;
    titleImage?: string;
    titleImageWidth?: string;
    children: ReactNode;
    id: string;
    defaultOpen?: boolean;
    marginLeftImage?: string;
    marginRightImage?: string;
    /** Render the title at sub-header (Title-S) scale instead of the default
     *  card-title scale — for sections nested inside a page, e.g. Devices. */
    compact?: boolean;
}

const FlushAccordian: React.FC<IFlushAccordian> = ({ title, titleImage, titleImageWidth, children, id, defaultOpen = true, marginLeftImage, marginRightImage, compact = false }) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);
    return (
        <>
            <div className="accordion accordion-flush mt-3" id={`accordionFlushExample${id}`}>
                <div className="accordion-item">
                    <h2 className="accordion-header" id={`flush-headingOne${id}`}>
                        {/* Collapse is driven by React state alone. It used to also carry
                            data-bs-toggle/data-bs-target, so Bootstrap's collapse JS fought
                            React over the same element: Bootstrap left an inline height on
                            the panel that React never cleared, which could strand a section
                            shut and made expand/collapse look absent. */}
                        <button
                            className={`accordion-button ${isOpen ? "" : "collapsed"} ${compact ? "accordion-button-compact" : ""}`}
                            type="button"
                            aria-expanded={isOpen ? "true" : "false"}
                            aria-controls={`flush-collapseOne${id}`}
                            style={{ paddingRight: '30px', paddingLeft: '8px' }}
                            onClick={() => setIsOpen(!isOpen)}
                        >
                            {
                                (titleImage!==undefined && titleImage!=null && titleImage!=="") ? <img src={titleImage} alt="titleImage" style={{marginRight: marginRightImage, width: titleImageWidth, marginLeft: marginLeftImage}}/> : <></>
                            }
                            {title}
                        </button>
                    </h2>
                    <div
                        id={`flush-collapseOne${id}`}
                        className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}
                        aria-labelledby={`flush-headingOne${id}`}
                    >
                        <div className="accordion-body mb-3">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default FlushAccordian;
